/* React */
import React from 'react';

/* Styled Components */
import {
  Illustration,
  Wrapper,
  Caption,
} from './styles';

export interface AddTeacherSuccessViewProps {
  caption?: String;
}

const AddTeacherSuccessView: React.FC<AddTeacherSuccessViewProps> = ({ caption }) => {
  return (
    <Wrapper>
      <Illustration />
      <Caption>{caption}</Caption>
    </Wrapper>
  );
};

export default AddTeacherSuccessView;
